import { noop } from 'lodash';
import React from 'react';
import cn from 'classnames';
import { r_check as CheckIcon } from '@fiverr-private/icons';
import { SUGGESTED_VARIATION } from '../../../propTypes';
import Variation from '../../base/Variation';
import './index.scss';

const SuggestedVariationCard = ({ id, selected = false, onSelect = noop, ...variation }) => (
    <div className={cn('suggested-variation-card', { selected })}>
        <Variation id={id} {...variation}/>
        <span onClick={() => onSelect(id)} className="select-circle">
            <CheckIcon/>
        </span>
    </div>
);

SuggestedVariationCard.propTypes = SUGGESTED_VARIATION;

export default SuggestedVariationCard;
